import { normalizePhone } from "./contact-validation.ts";

export const PHONE_COUNTRIES = [
  {
    callingCode: "+1",
    label: "🇺🇸 +1",
    value: "US",
  },
  {
    callingCode: "+52",
    label: "🇲🇽 +52",
    value: "MX",
  },
  {
    callingCode: "+380",
    label: "🇺🇦 +380",
    value: "UA",
  },
  {
    callingCode: "+48",
    label: "🇵🇱 +48",
    value: "PL",
  },
  {
    callingCode: "+1",
    label: "🇨🇦 +1",
    value: "CA",
  },
  {
    callingCode: "+49",
    label: "🇩🇪 +49",
    value: "DE",
  },
  {
    callingCode: "+44",
    label: "🇬🇧 +44",
    value: "GB",
  },
  {
    callingCode: "+46",
    label: "🇸🇪 +46",
    value: "SE",
  },
  {
    callingCode: "+358",
    label: "🇫🇮 +358",
    value: "FI",
  },
  {
    callingCode: "+1",
    label: "🇵🇷 +1",
    value: "PR",
  },
] as const;

export type PhoneCountry = (typeof PHONE_COUNTRIES)[number]["value"];

export function getPhoneCountry(country: string) {
  return (
    PHONE_COUNTRIES.find((option) => option.value === country) ??
    PHONE_COUNTRIES[0]
  );
}

function removeRepeatedCallingCode(phone: string, callingCode: string) {
  const repeatedCallingCode = `${callingCode}${callingCode}`;
  let normalizedPhone = phone;
  while (normalizedPhone.startsWith(repeatedCallingCode)) {
    normalizedPhone = `${callingCode}${normalizedPhone.slice(repeatedCallingCode.length)}`;
  }
  return normalizedPhone;
}

export function getInternationalPhone(phone: string, country: string) {
  const normalizedPhone = normalizePhone(phone);
  if (!normalizedPhone) {
    return "";
  }

  const selectedCountry = getPhoneCountry(country);
  const phoneWithOneCallingCode = removeRepeatedCallingCode(
    normalizedPhone,
    selectedCountry.callingCode
  );

  return phoneWithOneCallingCode.startsWith("+")
    ? phoneWithOneCallingCode
    : `${selectedCountry.callingCode}${phoneWithOneCallingCode}`;
}

export function resolvePhoneCountry(phone: string, country = "US") {
  const normalized = normalizePhone(phone);
  const current = getPhoneCountry(country);
  return normalized.startsWith("+") &&
    !normalized.startsWith(current.callingCode)
    ? (PHONE_COUNTRIES.find((option) =>
        normalized.startsWith(option.callingCode)
      )?.value ?? current.value)
    : current.value;
}
